/**
 * Tooltip for errors that happen while syncing data with server after inline editing
 * @internal
 */
export class ErrorTooltip {
    init(params) {
        const eGui = (this.eGui = document.createElement('div'));
        const message = params.value;
        eGui.classList.add('custom-tooltip');
        eGui.style['background-color'] = '#f14376';
        eGui.style['border'] = '1px inside';
        eGui.style['border-color'] = '#2e3339';
        eGui.style['border-radius'] = '4px';
        eGui.style['padding'] = '5px';
        eGui.style['box-shadow'] = '0px 4px 10px 0px rgba(0, 0, 0, 0.25);';
        eGui.innerHTML = `<span style='color: #000000; font-size: 10px'>${message}</span>`;
    }
    getGui() {
        return this.eGui;
    }
}
